import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";
import "../../common.css";
import { useNavigate } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const paymentStatusClass = {
  PENDING: "badge badge--pending",
  SUCCESS: "badge badge--completed",
  REFUNDED: "badge badge--refunded",
  CANCELLED: "badge badge--cancelled",
};

const orderStatusClass = {
  PENDING: "badge badge--pending",
  COMPLETED: "badge badge--completed",
  CANCELLED: "badge badge--cancelled",
  RETURNED: "badge badge--refunded",
};

const Payment = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const fetchOrderList = useCallback(async (page = 1) => {
    try {
      const res = await service.get(
        `${endpoints.payment_order.orderlist}?page=${page}&limit=10`,
        {},
        { skipToast: true },
      );

      console.log("PAYMENT RESPONSE", res.data);
      setOrders(res?.data?.data || []);
      setCurrentPage(res?.data?.pagination?.currentPage || 1);
      setTotalPages(res?.data?.pagination?.totalPages || 1);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchOrderList(currentPage);
  }, [currentPage, fetchOrderList]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="team-page">
      <div className="team-top">
        <h2>Payment & Orders</h2>
      </div>

      <div className="payment-table-wrap">
        <table className="payment-table">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Mission</th>
              <th>Amount</th>
              <th>Receipt</th>
              <th>Payment Status</th>
              <th>Order Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No orders found.
                </td>
              </tr>
            ) : (
              orders.map((order) => (
                <tr key={order.orderId}>
                  <td className="text-muted">{order.orderDate}</td>
                  <td>{order.challengeName}</td>
                  <td className="text-bold">${order.amount.toFixed(2)}</td>
                  <td>
                    {order.receiptUrl ? (
                      <a
                        href={order.receiptUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="download-btn"
                      >
                        &#8595; Download
                      </a>
                    ) : (
                      <button className="download-btn" disabled>
                        N/A
                      </button>
                    )}
                  </td>
                  <td>
                    <span
                      className={
                        paymentStatusClass[order.paymentStatus] ||
                        "badge badge--pending"
                      }
                    >
                      {order.paymentStatus.charAt(0) +
                        order.paymentStatus.slice(1).toLowerCase()}
                    </span>
                  </td>
                  <td>
                    <span
                      className={
                        orderStatusClass[order.orderStatus] ||
                        "badge badge--pending"
                      }
                    >
                      {order.orderStatus.charAt(0) +
                        order.orderStatus.slice(1).toLowerCase()}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-container">
        <button
          className="pagination-btn"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, index) => {
          const page = index + 1;

          return (
            <button
              key={page}
              className={`pagination-btn ${
                currentPage === page ? "active-page" : ""
              }`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          );
        })}

        <button
          className="pagination-btn"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Payment;
